import { Link, Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import {
  StyledStack,
  StyledButton,
  StyledSection,
  StyledLinkWrapper,
  SectionNameBannerStack,
} from './styles';
import { webServicesData } from './WebServices.data';
import type { WebServicesProps } from './WebServices.types';

export const WebServices = ({
  offerRef,
  ...props
}: WebServicesProps): React.ReactElement => {
  return (
    <>
      <StyledSection width="normal">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner type="section" text="Services" color="aquamarine" />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>

      <Offer
        title={webServicesData.mainText}
        description={webServicesData.description}
        data={webServicesData.services}
        CustomButton={
          <StyledLinkWrapper>
            <Link to="/contact">
              <StyledButton>Book a free consultation</StyledButton>
            </Link>
          </StyledLinkWrapper>
        }
        ref={offerRef}
      />
    </>
  );
};
